var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a73e8;}.cls-2{fill:#ea4335;}.cls-3{fill:#4285f4;}.cls-4{fill:#fbbc04;}.cls-5{fill:#34a853;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.03, 1.03), translate(3.5, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.45.78A8.09,8.09,0,0,0,5.8,3.29L9.63,6.51Z",
    transform: "translate(-3.91 -0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.8,3.29a8.07,8.07,0,0,0-1.89,5.2,9.06,9.06,0,0,0,.8,3.86L9.63,6.51Z",
    transform: "translate(-3.91 -0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12,5.4a3.09,3.09,0,0,1,3.1,3.09,3.06,3.06,0,0,1-.74,2l4.82-5.73a8.12,8.12,0,0,0-4.73-4L9.63,6.51A3.07,3.07,0,0,1,12,5.4Z",
    transform: "translate(-3.91 -0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12,11.59a3.1,3.1,0,0,1-3.1-3.1,3.07,3.07,0,0,1,.73-2L4.71,12.35A28.67,28.67,0,0,0,8.38,17.6l6-7.11A3.07,3.07,0,0,1,12,11.59Z",
    transform: "translate(-3.91 -0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.25,19.54c2.7-4.22,5.84-6.14,5.84-11a8.1,8.1,0,0,0-.91-3.73L8.38,17.6c.46.6.92,1.24,1.37,1.94C11.4,22.08,10.94,23.6,12,23.6S12.6,22.08,14.25,19.54Z",
    transform: "translate(-3.91 -0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLocation);
export default __webpack_public_path__ + "static/media/googleLocation.ec52670c67a019e17ddaa5b0b3744d2b.svg";
export { ForwardRef as ReactComponent };